<template>
  <div>
    <button :class="customClass" @click="handleClickLike()">
      <transition name="like-icon" mode="out-in">
        <i
          :key="item.liked"
          :class="item.liked ? 'fa fa-thumbs-up liked-icon' : 'fa fa-thumbs-o-up'"
          aria-hidden="true"
        ></i>
      </transition>
      <transition name="like-bounce" mode="out-in">
        <span :key="item.likes" class="like-number">
          {{ item.likes }}
        </span>
      </transition>
    </button>
  </div>
</template>
<script>

export default {
  props: {
    customClass: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods: {
    handleClickLike () {
      this.$emit('handleClickLike', this.item)
    }
  }
}
</script>
<style scoped>
.action-btn {
  border: none;
  padding: 6px 24px;
  border-radius: 9999px;
  font-size: 20px;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  background-color: #0000000d;
}

.liked-icon {
  color: #2196f3;
  transition: color 0.3s ease;
}

.like-bounce-enter-active {
  animation: bounce-up 0.4s ease;
}

.like-bounce-leave-active {
  display: none;
}

@keyframes bounce-up {
  0% {
    opacity: 0;
    transform: translateY(8px) scale(0.95);
  }
  60% {
    opacity: 1;
    transform: translateY(-3px) scale(1.05);
  }
  100% {
    transform: translateY(0) scale(1);
  }
}

.like-number {
  display: inline-block;
  margin-left: 6px;
  font-weight: bold;
  color: #444;
  font-size: 14px;
}
.like-icon-enter-active {
  animation: like-punch 0.4s ease;
}

@keyframes like-punch {
  0% {
    transform: scale(1);
    opacity: 0.7;
  }
  40% {
    transform: scale(1.4) rotate(-10deg);
    opacity: 1;
  }
  70% {
    transform: scale(1.1) rotate(5deg);
  }
  100% {
    transform: scale(1) rotate(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/view/video/components/LikeButton.vue